<template>
  <Teleport defer to="#modal-anchor">
    <div class="overlay-mask">
      <slot />
    </div>
  </Teleport>
</template>

<style lang="scss">
.overlay-mask {
  @include mixins.flex-center($horiz: center);
  background-color: rgba(0, 0, 0, 0.4);
  color: variables.$primitives-color-background-100;
  height: 100%;
  left: 0;
  pointer-events: auto;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 1102;
}
</style>